import { CampaignType, CampaignVisualStatus } from "@/@types/campaign";

export type SearchType = "name" | "sku" | "campaignCode" | "department";

export interface ICampaignFilters {
  search?: string;
  searchType?: SearchType;
  status?: CampaignVisualStatus[];
  campaignTypes?: CampaignType[];
  inEffect?: boolean;
  startDateFrom?: string;
  startDateTo?: string;
  endDateFrom?: string;
  endDateTo?: string;
  stores?: number[];
  storeCode?: number;
  itemCode?: string;
  createdBy?: string;
  order?: Record<string, "asc" | "desc">;
  meta: {
    page: number;
    perPage: number;
  };
}

export interface FilterStateCampaigns {
  filters: ICampaignFilters;
}

export const DEFAULT_CAMPAIGN_FILTERS: ICampaignFilters = {
  search: "",
  searchType: "name",
  campaignTypes: [CampaignType.PRO013],
  inEffect: false,
  order: {},
  meta: {
    page: 1,
    perPage: 20,
  },
};
